import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Details } from 'Routes/Details';
import { Home } from 'Routes/Home';
import Movie from 'Routes/Movie';
import Search from 'Routes/Search';
import Tv from 'Routes/Tv';

export const Router = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/movie" component={Movie} />
      <Route exact path="/movie/top-rated" component={Movie} />
      <Route exact path="/movie/now-playing" component={Movie} />
      <Route exact path="/tv" component={Tv} />
      <Route path="/tv/airing-today" component={Tv} />
      <Route path="/tv/top-rated" component={Tv} />
      <Route path="/search" component={Search} />
      <Route exact path="/movie/:id" component={Details} />
      <Route exact path="/tv/:id" component={Details} />
    </Switch>
  );
};
